import {defineStyleConfig} from '@chakra-ui/styled-system'

export default defineStyleConfig({
  baseStyle: {
    opacity: 1.0
  }
})
